import { shared } from './shared';

export const environment = {
   production: true,
   host: 'https://quickcrypt.org',
   apiHost: 'https://quickcrypt.org',
   appPublicKey: 'public-key1',
   ...shared,
};
